
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model, ControladorDeCurso } from '../../controlador-crear-curso';

    @Component( {
        name: "Componente",
        props: {},
        components: {
        }
    } )
    export default class Componente extends Vue
    {


        @Prop()
        public IdEditando: number;

        @Prop()
        public Abrir: boolean;
        @Watch( 'Abrir' )
        onAbrir()
        {
            this.Abierto = false;
            this.$nextTick( () => { this.Abierto = true; } );
        }

        public Nombre: string = 'https://www.youtube.com/embed/sqdBToCyMl4';
        public video: string = '';
        public get Video(): string
        {
            if ( this.video.includes( 'http' ) )
            {
                if ( this.video.includes( 'youtu.be' ) )
                {
                    this.video = "https://www.youtube.com/embed/" + this.video.eliminar( 'https://youtu.be/' );
                }
                else if ( this.video.includes( 'watch' ) )
                {
                    this.video = this.video.replace( 'watch?v=', 'embed/' );
                }
                return this.video;
            }
            return '';
        }


        public async guardar()
        {
            this.$emit( 'agregar', { Nombre: this.Nombre, URL: this.Video } );
            this.Abierto = false;
        }



        public Abierto: boolean = false;
        @Watch( 'Abierto' )
        async onAbierto()
        {
            if ( this.Abierto )
            {
                this.Nombre = '';
                this.video = '';
            }
        }
        public Estado: 'cargando' | 'guardando' | 'guardado' | 'error-al-guardar' | 'ok' | 'error' | 'vacio' | 'iniciado' = 'iniciado';

    }
